import { filterDuplicateDocuments, includesId } from '@utils/usefulFuncs';
import React from 'react';

export const useSelectedDocs = (preSelectedDocs) => {
  const [selectedDocs, setSelectedDocs] = React.useState(preSelectedDocs || []);
  const [isSelectingDocs, setIsSelectingDocs] = React.useState(false);

  const onSelectedDocsChange = (t) => setSelectedDocs(t);

  const handleAddDocument = (v) => {
    if (Array.isArray(v)) {
      onSelectedDocsChange((prevState) => filterDuplicateDocuments([...prevState, ...v]));
    } else {
      onSelectedDocsChange((prevState) => filterDuplicateDocuments([...prevState, v]));
    }
  };

  const handleRemoveDocument = (filenameOrFilenames) => {
    if (Array.isArray(filenameOrFilenames)) {
      onSelectedDocsChange((prevState) => prevState.filter((d) => !includesId(filenameOrFilenames, d.id)));
    } else {
      onSelectedDocsChange((prevState) => prevState.filter((d) => d.id !== filenameOrFilenames.id));
    }
  };

  const clearSelectedDocs = () => setSelectedDocs([]);

  return {
    selectedDocs,
    isSelectingDocs,
    setIsSelectingDocs,
    onSelectedDocsChange,
    clearSelectedDocs,
    handleAddDocument,
    handleRemoveDocument,
  };
};
